export const Language = {
  PL: 'pl',
  EN: 'en',
  CS: 'cs',
  SK: 'sk'
};